module.exports = __webpack_public_path__ + "img/tourist_attraction.5e9fae73.png";